/**
 * ExportErrorEmitter.ts
 * EventEmitter pour les erreurs d'export (permet de connecter ToastProvider depuis un service non-React)
 */
import { BrowserEventEmitter } from '../utils/BrowserEventEmitter';

export interface ExportErrorEvent {
  type: 'error' | 'warning' | 'success' | 'info';
  message: string;
  duration?: number;
}

class ExportErrorEmitter extends BrowserEventEmitter {
  private static instance: ExportErrorEmitter | null = null;

  static getInstance(): ExportErrorEmitter {
    if (!ExportErrorEmitter.instance) {
      ExportErrorEmitter.instance = new ExportErrorEmitter();
    }
    return ExportErrorEmitter.instance;
  }

  emitExportError(event: ExportErrorEvent): void {
    this.emit('export-error', event);
  }

  onExportError(handler: (event: ExportErrorEvent) => void): void {
    // P3 : EventEmitter typé en `(...args: unknown[])` ; cast pour signature spécifique.
    this.on('export-error', handler as (...args: unknown[]) => void);
  }

  offExportError(handler: (event: ExportErrorEvent) => void): void {
    this.off('export-error', handler as (...args: unknown[]) => void);
  }
}

export const exportErrorEmitter = ExportErrorEmitter.getInstance();
